import { AnimatePresence } from 'framer-motion';
import { useAuditLogContext } from '../../contexts/AuditLogProvider';
import { AuditLog } from '../../types/auditLogs';
import ShowLogDetailsModal from '../CommonComps/Modals/ShowLogDetailsModal';

const LogDetailsModalsContainer = () => {
  // integration of context hooks here
  const { auditLog, showLogDetails, setShowLogDetails } = useAuditLogContext();

  // rendering log details modals container component here
  return (
    <section>
      <AnimatePresence initial={false} mode='wait' onExitComplete={() => null}>
        {showLogDetails ? (
          <ShowLogDetailsModal
            auditLog={auditLog as AuditLog}
            handleModalClose={() => setShowLogDetails(false)}
          />
        ) : null}
      </AnimatePresence>
    </section>
  );
};

export default LogDetailsModalsContainer;
